export const ACTION_TYPE = {
  SET_DATA: "SET_DATA_NEWS",
};
const defaultState = {
  hasMore: true,
  data: [],
  paginate: null,
};
const reducers = (state = defaultState, actions) => {
  switch (actions.type) {
    case ACTION_TYPE.SET_DATA: {
      return actions.payload;
    }
    default:
      return state;
  }
};
export default reducers;
